export function cls(...args) {
  let str = ''
  for (const arg of args) {
    if (typeof arg === 'string') {
      str += ' ' + arg
    } else if (typeof arg === 'object') {
      for (const key in arg) {
        const value = arg[key]
        if (value) str += ' ' + key
      }
    }
  }
  return str
}

export function isInputFocused() {
  return document.activeElement?.tagName === 'INPUT' || document.activeElement?.tagName === 'TEXTAREA'
}

// if at least two indicators point to touch, consider it primarily touch-based:
const coarse = window.matchMedia('(pointer: coarse)').matches
const noHover = window.matchMedia('(hover: none)').matches
const hasTouch = navigator.maxTouchPoints > 0
export const isTouch = (coarse && hasTouch) || (noHover && hasTouch)

const prefix = 'sf2'

class LocalStorage {
  get(key, defaultValue = null) {
    const data = localStorage.getItem(`${prefix}_${key}`)
    if (data === undefined) return defaultValue
    let value
    try {
      value = JSON.parse(data)
    } catch (err) {
      console.error('error reading storage key:', `${prefix}_${key}`)
      value = null
    }
    if (value === undefined) return defaultValue
    return value || defaultValue
  }

  set(key, value) {
    if (value === undefined || value === null) {
      localStorage.removeItem(`${prefix}_${key}`)
    } else {
      const data = JSON.stringify(value)
      localStorage.setItem(`${prefix}_${key}`, data)
    }
  }

  remove(key) {
    localStorage.removeItem(`${prefix}_${key}`)
  }
}

export const storage = new LocalStorage()
